import React from "react";
import { RCCBadge, RCCTooltip } from "react-common-components";

export interface IBadgeMaps{
    label: React.ReactNode;
	layout?: "default" | "isSquare";
    tooltip: string;
    color?: "grey" | "purple" | "blue" | "red" | "yellow" | "green" | "black" | "orange" | "main";
    onClick?: () => void;
}

const BadgeMaps: React.FC<IBadgeMaps> = ({
	label,
	layout,
	tooltip,
	color,
	onClick
}) => (
	<RCCTooltip
		text={tooltip}
		color={color}
		position="bottom"
	>
		<RCCBadge 
			onClick={onClick}
			layout={layout}
			styleInline={color ? `padding: 2px 8px; font-size: 0.78rem; box-shadow: none; background-color: var(--${color})` : "padding: 2px 8px; font-size: 0.78rem; box-shadow: none; background-color: rgba(255,255,255,0.2);"}
		>
			{label}
		</RCCBadge>
	</RCCTooltip>
		
);

export default BadgeMaps;
